import React, { useContext, useEffect, useRef, useState } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import '../../../css/AlchemieQuestion.scss';
import { AlchemieInteractiveFrame } from 'alchemie-activity-frame';
import { ContentType, LessonMode } from '../../../Constants';
import responseManager from '../../managers/ResponseManager';
import responseService from '../../services/ResponseService';
import PrintQuestionNumber from './PrintQuestionNumber';
import HtmlComponent from '../HtmlComponent';
import { useTextHighlight } from '../../../hooks/useTextHighlight';
import highlightAnnotationService from '../../services/HighlightAnnotationService';
import useStyleEvents from '../../../hooks/useStyleEvents';
import UtilsService from '../../services/UtilsService';


const AlchemieQuestion = observer(({ lessonElementId }) => {
  const {
    messageManager,
    lessonManager,
    toolbarManager,
    userManager
  } = useContext(MobXProviderContext);

  const [shouldRenderFrame, setShouldRenderFrame] = useState(false);
  useStyleEvents(lessonElementId, `${lessonElementId}-alchemie-question`);


  const componentRef = useRef();
  const lessonElement = lessonManager.getLessonElement(lessonElementId);

  const model = lessonManager.getSlideModel(lessonElementId);
  const directions = model.directions || '';

  let message = null;
  let childLessonElementState = null;
  if (lessonElement.lessonElementIds.includes(lessonManager.currentLessonElementId)) {
    message = messageManager.getMessage(lessonElementId);
    childLessonElementState = responseManager.getLessonElementState(lessonManager.currentLessonElementId);
  }
  const readOnly = (childLessonElementState && childLessonElementState.readOnly) || lessonManager.isReadOnly;

  const findLastResponse = (childLessonElementId, lessonElementId) => {
    const lessonElement = lessonManager.getLessonElement(lessonElementId);
    const index = lessonElement.lessonElementIds.indexOf(childLessonElementId);

    for(let x = index -1 ; x > -1; x--) {
      const model = lessonManager.getSlideModel(lessonElement.lessonElementIds[x]);
      if(model.type === ContentType.ALCHEMIE_TEST_ITEM.type) {
        const childLessonElementState = responseManager.getLessonElementState(lessonElement.lessonElementIds[x]);
        if(model.unscored && childLessonElementState && childLessonElementState.cachedResponseAnswer) {
          childLessonElementState.cachedResponseAnswer.unscored = true;
        }
        return childLessonElementState.cachedResponseAnswer;
      }
    }
  
    return null;
  }

  let startString = '';
  let goal = '';
  let findResponse = findLastResponse(lessonManager.currentLessonElementId, lessonElementId);

  if (!UtilsService.isObjectNullOrEmpty(message)) {
     if(!UtilsService.isNullOrEmptyOrUndefined(message.goal)) {
      goal = message.goal;
     } else if(!UtilsService.isObjectNullOrEmpty(findResponse) && !UtilsService.isNullOrEmptyOrUndefined(findResponse.goal)) {
      goal = findResponse.goal;
     }
     
     if(!UtilsService.isNullOrEmptyOrUndefined(message.startCode)) {
      startString = message.startCode;
     } else if(!UtilsService.isObjectNullOrEmpty(findResponse)) { // if we dont have a start code, use the last response (if it exists)
      startString = findResponse.goal;
     }
  } else if (UtilsService.isObjectNullOrEmpty(message)){ // if we dont have a message (current child is not an AlchemieTestItem), use the last response (if it exists)
   
    if(!UtilsService.isObjectNullOrEmpty(findResponse)) {
      if(!UtilsService.isNullOrEmptyOrUndefined(findResponse.goal)) {
        goal = findResponse.goal;
       }
       if(!UtilsService.isNullOrEmptyOrUndefined(findResponse.startCode)) {
        startString = findResponse.startCode;
       }
    }
  }

  if (UtilsService.isNullOrEmptyOrUndefined(startString)) {
    startString = model.startCode;
  }
  

  // Parse config JSON string if it exists
  let params = {};
  if (model.config) {
    try {
      params = JSON.parse(model.config);
    } catch (e) {
      console.error('Failed to parse config JSON:', e);
    }
  }

  // If current child is AlchemieTestItem and has valid config, override params
  if (childLessonElementState && lessonManager.currentLessonElementId) {
    const childModel = lessonManager.getSlideModel(lessonManager.currentLessonElementId);
    if (childModel && childModel.type === ContentType.ALCHEMIE_TEST_ITEM.type && childModel.config) {
      try {
        params = JSON.parse(childModel.config);
      } catch (e) {
        console.error('Failed to parse child config JSON:', e);
      }
    }
  }

  if(!UtilsService.isNullOrEmptyOrUndefined(goal)) {
    params.loadedConfig = goal
  }

  if(readOnly) {
    params.readOnly = true;
  } else {
    params.readOnly = false;
  }

  if (!UtilsService.isNullOrEmptyOrUndefined(userManager.userId)) {
    params.userId = userManager.userId;
    console.log('AlchemieQuestion userId added to params', params.userId, params);
  }

  useTextHighlight(componentRef, lessonElementId);

  useEffect(() => {
    if (toolbarManager.isHighlightAnnotationOpen || toolbarManager.isToolOn('StickyNotes')) {
      highlightAnnotationService.showHighlights(lessonElementId);
    }
  });

  useEffect(() => {
    setShouldRenderFrame(false);
      const timer = setTimeout(() => {
        setShouldRenderFrame(true);
      }, 40);
    
    return () => clearTimeout(timer);
  }, [lessonManager.currentLessonElementId, readOnly]);

  const updateMessage = (e) => {
    if (e.data.type === 'configuration' && !readOnly) {
      if (lessonElement.lessonElementIds.includes(lessonManager.currentLessonElementId)) {
        const childMessage = messageManager.getMessage(lessonManager.currentLessonElementId);
        childMessage.goal = e.data.configuration;
        childMessage.from = lessonElementId;
        childMessage.isStartCode = false;
        messageManager.updateMessage(lessonManager.currentLessonElementId, childMessage);
        responseService.responseChangeHandler(e.data.configuration, lessonManager.currentLessonElementId);
        console.log(e.data.configuration);
      }
    }
  };
  console.log("params", params);
  console.log("goal", goal);
  console.log("startString", startString);
  return (
    <div className='alchemie-activity-question' id={`${lessonElementId}-activity-view`}>
      <div ref={componentRef} className='test-item-question lesson-element alchemie-question' id={`${lessonElementId}-alchemie-question`}>
        {(lessonManager.playerMode === LessonMode.PRINT_PREVIEW) && <PrintQuestionNumber model={model} />}
        {directions ?
          <div className='directions'><HtmlComponent htmlStr={directions} /></div>
          : null}
        {(model.alchemieUrl && lessonManager.currentLessonElementId && shouldRenderFrame) && (
          <div className='alchemieToolWrapper'>
            <AlchemieInteractiveFrame
              frameClass=''
              onInteractiveMessage={updateMessage}
              size='medium'
              src={model.alchemieUrl}
              start={startString}
              params={params} />
          </div>
        )}
      </div>
    </div>
  );
});

export default AlchemieQuestion;
